import React, { useState, useEffect, useContext } from 'react';
import Layout from '../components/Layout';
import { FaComments } from 'react-icons/fa';
import AppContext from '../api/AppContext';
import api from '../services/api';
import ChatWindow from '../components/ChatWindow';
import WhiteCard from '../components/WhiteCard';

const MemberChat = () => {
  const { user, socket } = useContext(AppContext);
  const [conversations, setConversations] = useState([]);
  const [activeConversation, setActiveConversation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const setActive = async (conv) => {
    setActiveConversation(conv);
    if (socket?.connected) {
      socket.emit('chat:join', { conversationId: conv._id });
    }
    try {
      await api.put(`/chat/conversations/${conv._id}/read`);
      localStorage.setItem('chat-unread-update', Date.now().toString());
      window.dispatchEvent(new CustomEvent('chat-unread-update'));
    } catch (err) {
      console.error('Erro ao marcar como lido:', err);
    }
  };

  const setActiveConversationAndJoin = async (conv) => {
    setActiveConversation(conv);
    if (socket?.connected) {
      socket.emit('chat:join', { conversationId: conv._id });
    }
    try {
      await api.put(`/chat/conversations/${conv._id}/read`);
      localStorage.setItem('chat-unread-update', Date.now().toString());
      window.dispatchEvent(new CustomEvent('chat-unread-update'));
    } catch (err) {
      console.error('Erro ao marcar como lido:', err);
    }
  };

  useEffect(() => {
    fetchConversations();
  }, []);

useEffect(() => {
  if (!socket || !activeConversation) return;

  const handleReconnect = () => {
    //console.log('MemberChat: socket reconectado, reentrando na conversa', activeConversation._id);
    socket.emit('chat:join', { conversationId: activeConversation._id });
  };

  socket.on('connect', handleReconnect);
  return () => {
    socket.off('connect', handleReconnect);
  };
}, [socket, activeConversation]);

const fetchConversations = async () => {
  try {
    setLoading(true);
    const response = await api.get('/chat/conversations');
    setConversations(response.data.data.conversations);
    const active = response.data.data.conversations.find(c => ['active', 'waiting'].includes(c.status));
    if (active) {
      setActiveConversationAndJoin(active);
    }
  } catch (err) {
    setError('Erro ao carregar conversas');
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const startNewConversation = async () => {
    try {
      const response = await api.post('/chat/conversations');
      const newConv = response.data.data.conversation;
      setConversations(prev => [newConv, ...prev]);
      setActive(newConv);
      setActiveConversationAndJoin(newConv);
      if (socket) socket.emit('chat:join', { conversationId: newConv._id });
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao iniciar conversa');
    }
  };

  const hasOpen = conversations.some(c => ['active', 'waiting'].includes(c.status));

  return (
    <Layout title="Atendimento" icon={FaComments} noBottomPadding>
      <div style={styles.container}>
        {activeConversation ? (
          <div style={styles.chatContainer}>
            <ChatWindow conversation={activeConversation} onBack={() => setActiveConversation(null)} />
          </div>
        ) : (
          <div style={styles.listContainer}>
            <WhiteCard>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h3 style={{ margin: 0, fontSize: '18px' }}>Atendimento</h3>
                {!hasOpen && (
                  <button onClick={startNewConversation} style={styles.startButton}>
                    Iniciar novo atendimento
                  </button>
                )}
              </div>
              {loading && <p>Carregando...</p>}
              {error && <p style={styles.error}>{error}</p>}
              {!loading && conversations.length === 0 && (
                <p style={{ textAlign: 'center', color: '#666' }}>Nenhuma conversa encontrada.</p>
              )}
              {conversations.map(conv => (
                <div key={conv._id} style={styles.conversationItem}>
                  <div style={styles.convInfo}>
                    <strong>Status: {conv.status === 'waiting' ? 'Aguardando' : conv.status === 'active' ? 'Em atendimento' : conv.status}</strong>
                    <p>Última mensagem: {conv.lastMessageAt ? new Date(conv.lastMessageAt).toLocaleString() : 'N/A'}</p>
                  </div>
                  <button onClick={() => setActiveConversationAndJoin(conv)} style={styles.viewButton}>
                    Ver
                  </button>
                </div>
              ))}
            </WhiteCard>
          </div>
        )}
      </div>
    </Layout>
  );
};

const styles = {
  container: { maxWidth: '800px', margin: '0 auto', overflow: 'hidden', },
  listContainer: { width: '100%', flex: 1, overflow: 'hidden', },
  chatContainer: { width: '100%', flex: 1, overflow: 'hidden', },
  error: { color: 'red' },
  startButton: { background: '#2563EB', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' },
  conversationItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderBottom: '1px solid #eee' },
  convInfo: { flex: 1 },
  viewButton: { background: '#1A3B7D', color: 'white', border: 'none', padding: '5px 15px', borderRadius: '5px', cursor: 'pointer' }
};

export default MemberChat;